import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useCartStore } from '@features/cart/model/useCartStore'

import Button from '@shared/ui/button'
import Input from '@shared/ui/input'

import styles from './styles.module.scss'

export default function DiscountControl () {
  const { t } = useTranslation('cart')
  // const [activeTab, setActiveTab] = useState("promo");
  const [ promoCode, setPromoCode ] = useState('')
  const { setPromocode } = useCartStore()

  // const tabs = [
  //   { label: t("discount.promocodes"), value: "promo" },
  //   { label: t("discount.bonuses"), value: "bonuses" },
  // ];

  const handleApplyPromo = () => {
    if (promoCode) {
      setPromocode(promoCode)
    }
  }

  return (
    <div className={styles.root}>
      {/* <TabsSwitcher
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
        className={styles.tabs}
      /> */}
      <div className={styles.promo}>
        <div className={styles.promo__input}>
          <Input
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            placeholder={t('discount.enter_promocode')}
            inputSize="large"
            className={styles.promo__field}
          />
          <Button className={styles.promo__button} onClick={handleApplyPromo}>
            <ReactSVG src="/icons/arrow-right.svg" />
          </Button>
        </div>
      </div>
      {/* {activeTab === "bonuses" && <BonusControl />} */}
    </div>
  )
}
